import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachesolrComponent } from './simple-icons-apachesolr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachesolrComponent ],
    exports:      [ SimpleIconsApachesolrComponent ],
    bootstrap:    []
})
export class SimpleIconsApachesolrModule {}
